module.exports = __webpack_public_path__ + "static/media/slider_banner_1.7e92f6c9.png";